<template>
  <div>
    <el-form inline label-width="80px" class="form">
      <el-form-item>
        <el-input placeholder="请输入内容" v-model="form.trackValue" class="select-input" clearable>
          <el-select v-model="form.trackKey" slot="prepend" placeholder="请选择">
            <el-option :label="label" :value="key" v-for="(label, key) in workMap" :key="key"></el-option>
          </el-select>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-input placeholder="请输入内容" v-model="form.singerValue" class="select-input" clearable>
          <el-select v-model="form.singerKey" slot="prepend" placeholder="请选择">
            <el-option :label="label" :value="key" v-for="(label, key) in singerMap" :key="key"></el-option>
          </el-select>
        </el-input>
      </el-form-item>

      <el-form-item>
        <el-input placeholder="请输入内容" v-model="form.albumValue" class="select-input" clearable>
          <el-select v-model="form.albumKey" slot="prepend" placeholder="请选择">
            <el-option :label="label" :value="key" v-for="(label, key) in albumMap" :key="key"></el-option>
          </el-select>
        </el-input>
      </el-form-item>

      <el-form-item label="状态">
        <el-select v-model="form.reviewStatus" placeholder="请选择" class="field" clearable>
          <el-option :label="label" :value="+key" v-for="(label, key) in statusMap" :key="key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="来源">
        <el-select v-model="form.fFrom" placeholder="请选择" class="field" clearable>
          <el-option :label="label" :value="+key" v-for="(label, key) in fromMap" :key="key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="提交用户">
        <el-input v-model="form.companyName" placeholder="请选择" class="field" clearable></el-input>
      </el-form-item>

      <el-form-item label="用户类型">
        <el-select v-model="form.companyType" placeholder="请选择" class="field" clearable>
          <el-option :label="label" :value="+key" v-for="(label, key) in userMap" :key="key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="申诉类型">
        <el-select v-model="form.appealType" placeholder="请选择" class="field" clearable>
          <el-option :label="label" :value="+key" v-for="(label, key) in auditMap" :key="key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="提交时间">
        <el-date-picker
          v-model="form.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="date-picker"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="handleSearch" :loading="searching">查 询</el-button>
    </el-form>

    <el-card>
      <el-table :data="list" v-loading="searching">
        <el-table-column label="流水id" prop="id"></el-table-column>
        <el-table-column label="提交用户" prop="companyName"></el-table-column>
        <el-table-column label="用户类型" v-slot="{ row }">
          {{ userMap[row.companyType] }}
        </el-table-column>
        <el-table-column label="作品名" prop="trackName"></el-table-column>
        <el-table-column label="艺人名" prop="singerName" v-slot="{ row }">
          {{ row.trackSingerList.map(singer => singer.singerName).join('、') }}
        </el-table-column>
        <el-table-column label="专辑名" prop="albumName"></el-table-column>
        <el-table-column label="提交时间" prop="insertTime"></el-table-column>
        <el-table-column label="来源" prop="fFrom" v-slot="{ row }">
          {{ fromMap[row.fFrom] }}
        </el-table-column>
        <el-table-column label="申诉类型" v-slot="{ row }">
          {{ auditMap[row.appealType] }}
        </el-table-column>
        <el-table-column label="状态" v-slot="{ row }">
          {{ statusMap[row.reviewStatus] }}
        </el-table-column>
        <el-table-column label="审核人" prop="reviewUserName"></el-table-column>
        <el-table-column label="审核时间" prop="modifyTime"></el-table-column>
        <el-table-column label="操作" v-slot="{ row }" width="120px" fixed="right">
          <el-button type="text" @click="handleClickAudit(row.id)" v-if="row.reviewStatus === 0">审核</el-button>
          <el-button type="text" @click="handleClickAudit(row.id)" v-else>查看</el-button>
          <el-button type="text" @click="handelClickHistory(row)">记录</el-button>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-sizes="[10, 50, 100, 1000, 2000]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
      <el-dialog
        :visible.sync="showHistory"
        title="审核记录"
        :close-on-click-modal="false"
        :append-to-body="true"
      >
        <history :list="historyList"></history>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import copyrightService from '@/api/copyright'
import dayjs from 'dayjs'
import History from '../detail/components/History.vue'

import { workMap, singerMap, albumMap, statusMap, fromMap, userMap, auditMap } from '../const'

export default {
  name: 'CpCheckList',

  components: {
    History
  },

  data() {
    return {
      workMap,
      singerMap,
      albumMap,
      statusMap,
      fromMap,
      userMap,
      auditMap,

      searching: false,
      showHistory: false,

      list: [],
      historyList: [],

      form: {
        trackValue: '',
        trackKey: 'trackName__contains',

        singerValue: '',
        singerKey: 'singerName__contains',

        albumValue: '',
        albumKey: 'albumName__contains',

        reviewStatus: '',
        fFrom: '',
        appealType: '',
        companyType: '',
        companyName: '',

        date: null
      },

      pagination: {
        current: 1,
        size: 10,
        total: 0,
      }
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    async fetchData() {
      this.searching = true
      const {
        trackKey, trackValue, albumKey, albumValue, singerValue, singerKey,
        appealType, fFrom, companyType, companyName, reviewStatus, date
      } = this.form

      const { size, current } = this.pagination

      const query = {
        [trackKey]: trackValue,
        [albumKey]: albumValue,
        [singerKey]: singerValue,
        num: size,
        page: current - 1,

        appealType,
        companyType,
        fFrom,
        companyName,
        reviewStatus,
      }

      if (date) {
        query.insertTime = [
          dayjs(date[0]).format('YYYY-MM-DD HH:mm:ss'),
          dayjs(date[1]).format('YYYY-MM-DD HH:mm:ss')
        ]
      }

      try {
        const { list, total } = await copyrightService.find(query)

        this.list = list
        this.pagination.total = total
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.searching = false
      }
    },
    handleSearch() {
      this.pagination.current = 1

      this.fetchData()
    },
    handleSizeChange(size) {
      this.pagination.size = size
      this.fetchData()
    },

    handleCurrentChange(current) {
      this.fetchData()
    },

    handleClickAudit(id) {
      this.$router.push({
        name: 'checkCpDetail',
        params: {
          id
        }
      })
    },

    handelClickHistory(row) {
      this.historyList = row.transferList
      this.showHistory = true
    }

  }
}
</script>

<style lang="scss" scoped>
.form .el-form-item {
  margin-bottom: 8px !important;
}

.select-input {
  width: 250px;

  ::v-deep {
    .el-select {
      width: 118px;
    }
  }
}

.field {
  width: 170px
}

.date-picker {
  width: 358px;
}
</style>
